import { useQuery } from '@tanstack/react-query'
import { substanceAPI, SubstanceFiche } from '../services/api'

/**
 * Hook pour récupérer une fiche substance par CAS
 * Utilise TanStack Query pour cache, loading states, et error handling
 */
export function useSubstance(cas: string | undefined) {
  return useQuery<SubstanceFiche, Error>({
    queryKey: ['substance', cas],
    queryFn: () => {
      if (!cas) {
        throw new Error('Numéro CAS requis')
      }
      return substanceAPI.getByCAS(cas)
    },
    enabled: !!cas,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 1,
  })
}

export default useSubstance
